import usedeletedata from '../../Hooks/useDeleteData';
import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import {
  Add_Projects,
  Delete_One_Project_Data,
  Get_All_Projects,
  Get_Error,
  Get_One_Project_Data,
  Update_Project,
  Get_Top_Projects_and_Analayse_For_Dashboard_Type,
} from '../Types';

//get all data Projects action
export const GetallProjectsdata = (params) => async (dispatch) => {
  try {
     const { limit = 10, page = 1 } = params;
    const res = await usegetdata(`/api/v1/Projectss?isprojectactivate=true&limit=${limit}&page=${page}`);

    dispatch({
      type: Get_All_Projects,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

export const GetallProjectsdatanotactivate = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Projectss?isprojectactivate=false`);

    dispatch({
      type: Get_All_Projects,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get one project data

export const Get_one_Project_Action = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Projectss/${id}`);

    dispatch({
      type: Get_One_Project_Data,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//insert new  data Projects action
export const AddNewProject = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/Projectss`, body);

    dispatch({
      type: Add_Projects,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update new  data Projects action
export const UpdateProjectData = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/Projectss/${id}`, body);

    dispatch({
      type: Update_Project,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//Update new  data Projects action
export const DeleteProjectAction = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/Projectss/${id}`);

    dispatch({
      type: Delete_One_Project_Data,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};













export const Get_Top_Projects_Anlasis_IN_DAshboard_Action = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users/projects/analysis/dashboard`);

    dispatch({
      type: Get_Top_Projects_and_Analayse_For_Dashboard_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};